export default {
  "link": "_link_mny2gg",
  "active": "_active_mny2gg"
};
